/**
 * @file claim-detail.component.ts
 */
import { Component, OnInit, Inject } from '@angular/core';
import { ClaimSearchResponse } from '../../interfaces/claim-search-response.interface';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClaimService } from '../../services/claim/claim.service';
import { ClaimSearchDetailsResponse } from '../../interfaces/claim-search-detail-response.interface';
import { MultilingualService } from '../../core/services/multilingual/multilingual.service';
import { AppCenterAnalytics } from '../../services/app-insights/app-insights';
import { AppInsightsService } from '../../services/app-insights/app-insights.service';

@Component({
  selector: 'app-claim-detail',
  templateUrl: './claim-detail.component.html',
  styleUrls: []
})
export class ClaimDetailComponent implements OnInit {
  isLoading = false;
  error = false;
  errMsg!: string;
  claimDetails!: ClaimSearchDetailsResponse;

  constructor(
    @Inject(MAT_DIALOG_DATA) public claim: ClaimSearchResponse,
    private readonly claimService: ClaimService,
    private readonly appInsightsService: AppInsightsService,
    public readonly multilingualService: MultilingualService
  ) { }

  ngOnInit(): void {
    this.appInsightsService.trackPageView(AppCenterAnalytics.CLAIMS_DETAILS_VIEWED, {
      data: {
        claimId: this.claim.claimId,
        personCode: this.claim.personCode
      }
    });
    this.getClaim(this.claim);
  }

  private getClaim(claim: ClaimSearchResponse): void {
    this.isLoading = true;
    this.claimService.getClaimDetailsByClaimId(claim.claimId, claim.personCode).subscribe((res) => {
      this.claimDetails = res;
      this.isLoading = false;
    }, (err) => {
      this.error = true;
      this.isLoading = false;
      this.errMsg = err;
    });
  }
}
